import React, {Fragment} from "react";
import imageKozijn from '../../../images/situation/maten/kozijn/T.jpg';
import imageMuur from '../../../images/situation/maten/muur/T.jpg';
import PropTypes from "prop-types";

export default function MaatT(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u de maat tussen muur en luik invullen.<br/>
            <br/>
            {props.isMuurMontage
                ? <>Voor muurmontage zal dit een "pasmaat" zijn, bijvoorbeeld 5mm.</>
                : <>Om de inschroefduim in het kozijn te kunnen draaien, moet dit in het algemeen meer zijn dan 45mm.</>}
        </div>
        <img className="explainImage" src={props.isMuurMontage ? imageMuur : imageKozijn} alt=""/>
    </Fragment>;
}

MaatT.propTypes = {
    isMuurMontage: PropTypes.bool.isRequired
}